import Login from "@Rocket-Innovation/components/app/crm/client/login/components/Login";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import LanguageStore from "@Rocket-Innovation/components/store/languageStore";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { authApi, merchantApi } from "@api";
import { ComponentMenuBar, IConUser, ProgressBar, ShareIcon } from "@components";
import { PATH_MY_QR, enumLanguage, enumNavigation, enumTheme } from "@configs";
import { IInfo, IMemberShipTiers, IMerchant } from "@interfaces";
import liff from "@line/liff";
import {
    selectApp,
    selectMerchant,
    setDetailUser,
    setMerchant,
    setMerchantPrefix,
    store,
} from "@redux";
import { RenderMeta, numberFormatter } from "@utils";
import { Coupon, IconCoinSub, IconStarCircle } from "../Components/icon";

import { getPrefix } from "@Rocket-Innovation/components/utilities/getPrefix";
import { Avatar, Button, Carousel, Flex, Input, Skeleton, Tabs } from "antd";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { MouseEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { RWebShare } from "react-web-share";
import { isUserInactiveFor } from "src/Helpers/useActivities";
import { useFullScreen } from "src/Helpers/useFullscreen";
import { formatDateNumber } from "src/Utils/dateUtil";
import styled, { CSSProperties } from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { LangDropdown } from "./LangDropdown";
import AvatarProfile from "./home/AvatarProfile";
import Banner from "./home/Banner";
import CustomOtherMenu from "./home/CustomOtherMenu";
import CustomProfile2ndLine from "./home/CustomProfile/CustomProfile2ndLine";
import CustomProfile3rdLine from "./home/CustomProfile/CustomProfile3rdLine";
import CustomProfileCircle from "./home/CustomProfileCircle";
import CustomProfileMain from "./home/CustomProfileMain";
import LayoutClickBox from "./home/LayoutClickBox";
import { IconPoint } from "./icon/IconPoint";
import { BudgeButton } from "./shared";

interface IProps {
    themeColor: string;
    userInfo: IInfo | null;
    memberShipTiers: IMemberShipTiers[];
    under: enumNavigation;
    handleToggleUnder: (value: enumNavigation) => void;
    handleToggleQrCode: () => void;
    handleSwitchUserSetting: () => void;
    handleSwitchTier: () => void;
}

export interface ITypeDetail {
    typeName: string;
    typeIcon: string;
}

const styleAvatarUser: CSSProperties = {
    marginTop: "-52px",
    width: "64px",
    height: "64px",
};
const styleCircleImg: CSSProperties = {
    width: "64px",
    height: "64px",
};
export const ComponentHome = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const { lang } = useSelector(selectApp);
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || enumTheme.LIGHT;
    const merchant = useSelector(selectMerchant);
    const merchantId = merchant?._id;
    const [pointValue, setPointValue] = useState<any>({});
    const token = UserStore.getState().accessToken ?? store.getState().auth.auth?.accessToken;
    const [isLine, setIsLine] = useState<boolean>(false);
    const setComponentsLanguage = LanguageStore.getState().setLanguage;
    //page variable
    const {
        themeColor,
        userInfo,
        memberShipTiers,
        under,
        handleToggleUnder,
        handleToggleQrCode,
        handleSwitchUserSetting,
        handleSwitchTier,
        // handleCoupon,
    } = props;
    const [tab, setTab] = useState<string>("1");
    const [selelrId, setSellerId] = useState<string>("");

    const [isLoading, setIsloading] = useState(false);
    const [showTextLeft, setShowTextLeft] = useState<boolean>(false);
    const [showTextRight, setShowTextRight] = useState<boolean>(false);
    const [nonLogin, setNonLogin] = useState<boolean>(true);
    const [showNews, setShowNews] = useState<boolean>(false);
    const [detailText, setDetailText] = useState<string>("Coupon");
    const [EYPoint, setEYPOint] = useState<any>();
    const [expirePoint, setExpirePoint] = useState<any>();

    const [typeDetail, setTypeDetail] = useState<ITypeDetail>({
        typeName: "",
        typeIcon: "",
    });
    const [newsList, setNewsList] = useState<any[]>([]);
    // current membership used bath
    const currentPoint = userInfo?.totalPoints || 0;
    const currentTierPointThreshold = userInfo?.memberTier?.pointThreshold || 0;
    // next membership
    const nextTiers = memberShipTiers?.filter(
        (item) =>
            item.pointThreshold > currentPoint &&
            item._id !== userInfo?.memberTier?._id &&
            item.pointThreshold > currentTierPointThreshold
    );
    const sortNextTiers = nextTiers.sort(
        (first, second) => first.pointThreshold - second.pointThreshold
    );
    const nextTierAmount = sortNextTiers.length > 0 ? sortNextTiers[0]?.pointThreshold : 0;
    // calculate percentage of next lvl and current
    const percentage = (+currentPoint / +nextTierAmount) * 100;
    // last active profile
    // const lastUpdatedDate = userInfo?.lastActive || "";

    const [tierColor, setTierColor] = useState<string>("#ffffff");
    const i18nextLng = window.localStorage.i18nextLng;

    const isTechDomain = () => {
        const currentURL = window.location.href;
        const regex = /\.app$/i;
        return regex.test(currentURL);
    };

    const fullHeight = useFullScreen();

    useEffect(() => {
        const fetchMerchantConfigByPrefix = async () => {
            if (merchantId) return;

            const prefix = getPrefix();
            if (prefix) {
                dispatch(setMerchantPrefix(prefix));
            }

            try {
                const res = await merchantApi.getMerchantConfigPrefix();
                const merchantData =
                    res?.data?.data?.merchant ||
                    res?.data?.merchant ||
                    res?.data?.data ||
                    res?.data;

                if (merchantData && (merchantData as IMerchant)._id) {
                    dispatch(setMerchant(merchantData as IMerchant));
                }
            } catch (error) {
                console.error("getMerchantConfigPrefix failed", error);
            }
        };

        fetchMerchantConfigByPrefix();
    }, [dispatch, merchantId]);

    useEffect(() => {
        const lang = localStorage.getItem("lang");
        const locale = lang === "ENGLISH" ? "en" : "th";
        LanguageStore.getState().setLanguage(locale);
        // liff.init({
        //     liffId:
        //         !isTechDomain() && merchant?.lineIntegration?.lineLoginApi?.liffUrl
        //             ? merchant?.lineIntegration?.lineLoginApi?.liffUrl
        //             : isTechDomain() &&
        //               merchant?.lineIntegration?.lineLoginApi?.liffUrlForProduction
        //             ? merchant?.lineIntegration?.lineLoginApi?.liffUrlForProduction
        //             : "1660728826-zZpNNQAV",
        // });
        let tierList = merchant?.memberShipTiers;
        let thisTier = tierList?.find(
            (x: any) => x.membershipName === userInfo?.memberTier?.tierName
        );
        setTierColor(thisTier?.color || "#ffffff");
        findNextTier();
        if (userInfo?.contact?.sellerId) {
            setSellerId(userInfo?.contact?.sellerId);
        }
        merchant?.themes?.basicThemeSetting?.pointsDisplay?.pointsText?.forEach(
            (pItem: any, pIndex: number) => {
                // Coupon , Member since, X points to expire by end of year
                if (pItem.isStatus) {
                    setDetailText(pItem.name);
                }
            }
        );
        if (merchant?.themes?.sellerThemeSetting?.highlightMenu?.menuLeft === "News") {
            findNewsList();
        }

        findMemberTypeDetail();
    }, [userInfo, merchant]);

    const findMemberTypeDetail = () => {
        setTypeDetail({
            typeName: userInfo?.contact?.memberTypeName!,
            typeIcon: userInfo?.contact?.memberTypeNameIcon!,
        });
        // if (typeDetail.typeName === "" || typeDetail.typeIcon === "") {
        //     let gDetail = merchant?.memberTypeConfig?.memberTypeGroupName?.find(
        //         (fItem: any) => fItem._id === userInfo?.contact?.memberTypeGroupNameId
        //     );
        //     if (gDetail?.typeGroupNameList) {
        //         let tDetail = gDetail?.typeGroupNameList?.find(
        //             (gItem: any) => gItem?._id === userInfo?.contact?.memberTypeNameId
        //         );
        //         let payload: ITypeDetail = {
        //             typeName: tDetail?.typeName || "",
        //             typeIcon: tDetail?.typeNameIcon || "",
        //         };
        //         setTypeDetail(payload);
        //     }
        // }
    };

    const findEndYearPoint = async () => {
        await null;
        let res = await merchantApi.getEndYearPoint();
        setEYPOint(res.data ? res.data : { lastYearOfYear: 0, totalPoints: 0 });
    };

    const findNewsList = async () => {
        let res = await merchantApi.getNewsList();
        setNewsList(res.data.docs);
    };

    const findNextTier = () => {
        let tierList = merchant?.memberShipTiers || [];
        let thisIndex = tierList?.findIndex(
            (x: any) => x.membershipName === userInfo?.memberTier?.tierName
        );
        let isLast = false;
        if (thisIndex === -1 || thisIndex === tierList?.length - 1) {
            isLast = true;
        }
        let attPer = merchant?.advanceSettings?.tier?.isPointBalance
            ? userInfo?.percentToNextTierPointBalance
            : userInfo?.percentToAttain;

        let item = {
            isBalance: merchant?.advanceSettings?.tier?.isPointBalance,
            lastTier: isLast,
            nextTierPoint: userInfo?.pointEarnToAttain - userInfo?.allPointEarn,
            nextTierPointSaleEarn: userInfo?.pointEarnToAttain - userInfo?.allSaleEarn,
            nextTierName: isLast ? "-" : tierList[thisIndex + 1]?.membershipName,
            thisTierName: tierList?.[thisIndex]?.membershipName,
            attentPercent: attPer,
            totalPoint: userInfo?.totalPoints,
            pointNextTierBalance: userInfo?.BalancePointToNextTier - userInfo?.totalPoints,
            setBalance: merchant?.advanceSettings?.tier?.isPointBalance,
            setEarn: merchant?.advanceSettings?.tier?.isPointEarn,
        };
        setPointValue(item);
    };

    useEffect(() => {
        if (token) {
            setIsloading(true);
            fetchInvite();
            findEndYearPoint();
            fetchExpirePoint();
        }
    }, [token]);

    const fetchExpirePoint = async () => {
        let res = await authApi.getExpirePoint();
        setExpirePoint(res.data);
    };
    const fetchInvite = async () => {
        if (userInfo?.contact?.sellerId) {
            try {
                let res = await merchantApi.getInviteLinkSeller();
                let url =
                    merchant?.prefix +
                    "." +
                    process.env.REACT_APP_CLIENT_URL +
                    "/invite/" +
                    res.data.inviteId;
                setInviteUrl(url);
                if (res.data !== "not have this feature (invite seller)") {
                    setHaveInvite(true);
                }
            } catch (error) {
                setIsloading(false);
            }
        } else {
            try {
                let res = await merchantApi.getInviteLink();
                if (res.data?.inviteId) {
                    setHaveInvite(true);
                    let url =
                        merchant?.prefix +
                        "." +
                        process.env.REACT_APP_CLIENT_URL +
                        "/invite/" +
                        res.data.inviteId;
                    setInviteUrl(url);
                }

                // REACT_APP_CLIENT_URL
                // process.env.REACT_APP_CLIENT_URL
            } catch (error) {
                setIsloading(false);
            }
        }

        setIsloading(false);
    };

    const handleDetail = () => {
        dispatch(setDetailUser());
    };
    const coverSlide = (currentSlide: number) => {
        //
    };
    const newsSlide = (currentSlide: number) => {
        //
    };

    const promotionSlide = (currentSlide: number) => {
        //
    };

    const contentPromotionSlide = (currentSlide: number) => {
        //
    };
    const subContentPromotionSlide = (currentSlide: number) => {
        //
    };

    const modeColor = themeMode === enumTheme.DARK ? "#f1f1f1" : "#000000";
    const { TabPane } = Tabs;

    function callback(items: any) {
        setTab(items);
        handleToggleUnder(Number(items));
    }

    const [haveInvite, setHaveInvite] = useState<boolean>(false);
    const [inviteUrl, setInviteUrl] = useState<string>("");
    const [showpopupinvite, setShowPopupInvite] = useState<boolean>(false);
    const [showVideo, setShowVideo] = useState<boolean>(false);

    const copyText = () => {
        navigator.clipboard.writeText("https://" + inviteUrl);
    };
    const openLiff = async () => {
        const liffUrl = await liff.permanentLink.createUrlBy(window.location.href);
        window.location.href = liffUrl;
    };

    const RenderInviteFriend = () => {
        const isInactive = isUserInactiveFor(1.5);

        if (haveInvite) {
            return (
                <LazyMotion features={domAnimation}>
                    <AnimatePresence>
                        {isInactive && (
                            <m.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="box-invite-friend"
                                onClick={() => {
                                    setShowPopupInvite(true);
                                }}
                            >
                                <img
                                    src={merchant?.themes?.basicThemeSetting?.iconGeneral[2].image}
                                    alt="invite-friend"
                                />
                            </m.div>
                        )}
                    </AnimatePresence>
                </LazyMotion>
            );
        } else {
            return null;
        }
    };

    const shareContent = async () => {
        await null;
        try {
            let shareData = {
                title: "Invite url",
                text: "invite url",
                url: "", // Initialize with an empty string
            };

            if (inviteUrl) {
                try {
                    const url = new URL(inviteUrl);
                    shareData.url = ("https://" + url).toString(); // Convert to a valid URL string
                } catch (error) {
                    console.error("Invalid URL:", error);
                    return; // Exit the function if URL is invalid
                }
            } else {
                console.error("No invite URL provided.");
                return; // Exit the function if no URL is provided
            }

            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                console.error("Web Share API is not supported in your browser.");
            }
        } catch (error) {
            console.error("Error sharing:", error);
        }
    };

    const handleClickMenu = (path: string) => {
        if (!path) return;

        if (path[0] === "/") {
            history.push(path);
        } else if (
            path.includes("pos-client") ||
            path.includes("service-client") ||
            path.includes("rocket-booking") ||
            path.includes("eventease")
        ) {
            window.open(`${path}/auth/${token}?lang=${lang === "THAI" ? "th" : "en"}`, "_self");
        } else if (
            path.includes("rocket-ecommerce") ||
            path.includes("fudidiworld") ||
            path.includes("drpongskinclub")
        ) {
            let originUrl = new URL(path).origin;
            let pathName = new URL(path).pathname;
            window.open(
                `${originUrl}/auth/${token}?lang=${
                    lang === "THAI" ? "th" : "en"
                }&redirect=${pathName}`,
                "_self"
            );
        } else {
            window.open(path, "_self");
        }
    };

    const handleClickBottomMenu = (path: string) => {
        if (!path) return;

        if (path[0] === "/") {
            history.push(path);
        } else if (
            path.includes("pos-client") ||
            path.includes("service-client") ||
            path.includes("rocket-booking") ||
            path.includes("eventease")
        ) {
            window.open(`${path}/auth/${token}?lang=${lang === "THAI" ? "th" : "en"}`, "_self");
        } else if (
            path.includes("rocket-ecommerce") ||
            path.includes("fudidiworld") ||
            path.includes("drpongskinclub")
        ) {
            let originUrl = new URL(path).origin;
            let pathName = new URL(path).pathname;
            window.open(
                `${originUrl}/auth/${token}?lang=${
                    lang === "THAI" ? "th" : "en"
                }&redirect=${pathName}`,
                "_self"
            );
        } else {
            window.open(path, "_self");
        }
    };

    const resolveMenuPath = (item: any) => item?.linkWeb || item?.linkweb || "";
    const preventDefaultLinkNavigation = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
    };

    const [isClicked, setIsClicked] = useState(false);
    const handleClickRead = () => {
        setIsClicked(!isClicked);
    };

    if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi) {
        let elementToHide: HTMLElement | null = document.getElementById("bannersme");

        if (elementToHide) {
            elementToHide.style.display = "none";
        }
    }

    // if (merchant?.customizeProfile?.secondLine[0]?.name === "memberType") {

    // }

    const renderCorporateUi = () => {
        if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi) {
            return (
                <>
                    <RenderMeta title="Homepage" />
                    {userInfo?.contact?.sellerId === "" ||
                    userInfo?.contact?.sellerId === undefined ? (
                        <StyledMainPage
                            style={{ height: fullHeight }}
                            themeColor={themes?.themeColor!}
                        >
                            <div className="corp-lang">
                                <LangDropdown {...{ setComponentsLanguage }} />
                            </div>
                            <div className="wrapper-mainpage">
                                <Banner
                                    {...{ merchant, isLoading, coverSlide, handleClickBottomMenu }}
                                />
                                <div className="layout-profile">
                                    <Skeleton
                                        avatar
                                        active
                                        loading={isLoading}
                                        title={{ width: 185 }}
                                        paragraph={{ width: [171, 171] }}
                                    >
                                        <div className="box-profile">
                                            {!userInfo ? (
                                                <div className="non-login">
                                                    <div className="content-non-login">
                                                        <div className="title-non-login">
                                                            <span>
                                                                <Avatar
                                                                    className="circle-avatar-user"
                                                                    shape="circle"
                                                                    alt="Avatar"
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.logoSmallUrl ||
                                                                        "../../images/logo-rocket-short.svg"
                                                                    }
                                                                />
                                                                {/* <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.logoSmallUrl ||
                                                                        "../../images/logo-rocket-short.svg"
                                                                    }
                                                                    style={{
                                                                        width: "35px",
                                                                        height: "35px",
                                                                        borderRadius: "50%",
                                                                    }}
                                                                    alt=""
                                                                /> */}
                                                            </span>
                                                            {t("page.welcome_to")} {merchant?.name}
                                                        </div>
                                                        <div className="desc-non-login">
                                                            {t("page.sign_up_now_get")}{" "}
                                                            <IconPoint />{" "}
                                                            <span>
                                                                {merchant?.initPoint}{" "}
                                                                {t("page.point")}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <StyledBtnNonLogin
                                                        themeColor={themeColor}
                                                        onClick={() =>
                                                            UIStore.setState({
                                                                useDrawer: true,
                                                                drawerContent: (
                                                                    <span
                                                                        style={{
                                                                            color: "black",
                                                                        }}
                                                                    >
                                                                        <Login />
                                                                    </span>
                                                                ),
                                                            })
                                                        }
                                                    >
                                                        {t("page.login")}
                                                    </StyledBtnNonLogin>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="layout-name-profile">
                                                        <AvatarProfile {...{ userInfo }} />
                                                        {merchant?.themes?.basicThemeSetting
                                                            ?.pointsDisplay?.pointsSize ===
                                                        "large" ? (
                                                            <>
                                                                <div className="layout-detail-profile">
                                                                    <div className="name text-sub-header">
                                                                        {merchant?.superAdminTier
                                                                            ?.isFullName
                                                                            ? userInfo?.contact
                                                                                  ?.fullName
                                                                            : userInfo?.contact
                                                                                  ?.firstName +
                                                                              " " +
                                                                              userInfo?.contact
                                                                                  ?.lastName}{" "}
                                                                    </div>
                                                                </div>
                                                                {merchant?.themes
                                                                    ?.customizeProfile && (
                                                                    <CustomProfileMain
                                                                        {...{
                                                                            merchant,
                                                                            typeDetail,
                                                                            userInfo,
                                                                            pointValue,
                                                                            EYPoint,
                                                                            expirePoint,
                                                                        }}
                                                                    />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="layout-detail-profile">
                                                                <div className="name text-sub-header">
                                                                    {merchant?.superAdminTier
                                                                        ?.isFullName
                                                                        ? userInfo?.contact
                                                                              ?.fullName
                                                                        : userInfo?.contact
                                                                              ?.firstName +
                                                                          " " +
                                                                          userInfo?.contact
                                                                              ?.lastName}{" "}
                                                                    {/* <div className="tooltip-profile" onClick={() => history.push(PATH_PROFILE)}>
                                                                <StyledTooltip themeColor={themes?.themeColor!}>{t("page.myprofile")}</StyledTooltip>
                                                            </div> */}
                                                                </div>

                                                                {merchant?.themes
                                                                    ?.customizeProfile && (
                                                                    <CustomProfileMain
                                                                        {...{
                                                                            merchant,
                                                                            typeDetail,
                                                                            userInfo,
                                                                            pointValue,
                                                                            EYPoint,
                                                                            expirePoint,
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {merchant?.advanceSettings?.advanceFeature
                                                        ?.isMemberShipTier && (
                                                        <div className="layout-tier-right">
                                                            <div className="layout-box-circular">
                                                                <CustomProfileCircle
                                                                    merchant={merchant as IMerchant}
                                                                    userInfo={userInfo}
                                                                    pointValue={pointValue}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <Flex
                                                        flex={"1 1 100%"}
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        {``}
                                                    </Flex>
                                                </>
                                            )}
                                        </div>
                                    </Skeleton>
                                </div>
                                {merchant?.themes?.menuLeft === "" ? null : (
                                    <div className="wrapper-ld-mission">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <Skeleton
                                                    active
                                                    loading={isLoading}
                                                    title={false}
                                                    paragraph={{ rows: 2, width: [150, 100] }}
                                                >
                                                    <LayoutClickBox
                                                        merchant={merchant as IMerchant}
                                                        userInfo={userInfo}
                                                        themeColor={themes?.themeColor!}
                                                    />
                                                </Skeleton>
                                            </>
                                        ) : (
                                            <>
                                                <Skeleton
                                                    active
                                                    loading={isLoading}
                                                    title={false}
                                                    paragraph={{ rows: 2, width: [150, 100] }}
                                                >
                                                    <LayoutClickBox
                                                        merchant={merchant as IMerchant}
                                                        userInfo={userInfo}
                                                        themeColor={themes?.themeColor!}
                                                    />
                                                </Skeleton>
                                            </>
                                        )}
                                    </div>
                                )}
                                <CustomOtherMenu
                                    merchant={merchant as IMerchant}
                                    token={token}
                                    history={history}
                                    isloadding={isLoading}
                                />
                                <div className="wrapper-promotion">
                                    <Skeleton
                                        loading={isLoading}
                                        active
                                        title={{ width: 115 }}
                                        paragraph={{ rows: 1 }}
                                    >
                                        <Carousel
                                            afterChange={promotionSlide}
                                            dots={
                                                merchant?.promotion &&
                                                merchant?.promotion?.length > 1
                                                    ? true
                                                    : false
                                            }
                                        >
                                            {merchant?.promotion?.map((item: any, index: any) => (
                                                <div
                                                    className="main-cover-promotion"
                                                    key={index}
                                                    onClick={() =>
                                                        handleClickMenu(item.promotionLink)
                                                    }
                                                >
                                                    <span>
                                                        {item.promotionImage.endsWith(".mp4") ? (
                                                            // <div onClick={ () => {setShowVideo(true)} }>
                                                            <video
                                                                width="100%"
                                                                height="100%"
                                                                poster={
                                                                    item.promotionVideoPosterImage
                                                                }
                                                                controls
                                                            >
                                                                <source
                                                                    src={item.promotionImage}
                                                                    type="video/mp4"
                                                                />
                                                            </video>
                                                        ) : (
                                                            // </div>
                                                            <img
                                                                src={item.promotionImage}
                                                                alt="coverpromotion"
                                                            />
                                                        )}
                                                    </span>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </Skeleton>

                                    <div className="layout-banner-sq">
                                        <Skeleton
                                            loading={isLoading}
                                            active
                                            title={false}
                                            paragraph={{ rows: 1 }}
                                        >
                                            {merchant?.themes?.banner &&
                                                merchant?.themes?.banner[0]?.bannerSquare?.map(
                                                    (item: any, index: any) => (
                                                        <div
                                                            className="box-banner-sq"
                                                            key={index}
                                                            onClick={
                                                                () =>
                                                                    handleClickMenu(item.bannerLink)
                                                                // history.push(item.bannerLink)
                                                            }
                                                        >
                                                            <img src={item.bannerImage} alt="" />
                                                        </div>
                                                    )
                                                )}
                                        </Skeleton>
                                    </div>
                                    {/* <div className="layout-newproduct">
                                        <div className="box-newproduct">
                                            <a href="">
                                                <img src="../images/img-new-product.png" alt="covernewproduct" />
                                            </a>
                                        </div>
                                        <div className="topic-newproduct">New Product</div>
                                        <div className="name-newproduct">
                                            Kuliko Drink <span>1+1</span>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <RenderInviteFriend />
                            {showpopupinvite ? (
                                <StyledPopupInvite themeColor={themes?.themeColor!}>
                                    <div className="box-popupinvite">
                                        <div className="img-popupinvite">
                                            <img
                                                src={
                                                    merchant?.themes?.basicThemeSetting
                                                        ?.iconGeneral[1].image
                                                }
                                                alt=""
                                            />
                                        </div>
                                        <div className="detail-popupinvite">
                                            <div className="title-popupinvite">
                                                <div className="icon-title">
                                                    <IconPoint />{" "}
                                                </div>
                                                {userInfo?.contact?.sellerId &&
                                                merchant?.inviteSellerRule?.isPoint
                                                    ? merchant?.inviteSellerRule?.isPoint
                                                    : merchant?.inviteFriendRules?.isPoint
                                                    ? merchant?.inviteFriendRules?.isPoint
                                                    : ""}{" "}
                                                {t("page.point")}
                                            </div>
                                            <div className="title-popupinvite">
                                                {userInfo?.contact?.sellerId ? (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t(
                                                                "page.invitefriend.friend_sign_title"
                                                            )}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.friend_collect_title"
                                                            )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t(
                                                                "page.invitefriend.seller_sign_title"
                                                            )}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.seller_collect_title"
                                                            )}
                                                    </>
                                                )}
                                                {/* {userInfo?.contact?.sellerId
                                                    ? t("page.invitemembertoget")
                                                    : t("page.invitefriendtoget")}{" "} */}
                                            </div>
                                            <div className="desc-popupinvite">
                                                {/* {userInfo?.contact?.sellerId
                                                    ? t("page.pleasecopyinvitemember")
                                                    : t("page.pleasecopyinvitefriend")} */}
                                                {userInfo?.contact?.sellerId ? (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t("page.invitefriend.friend_sign_desc")}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.friend_collect_desc"
                                                            )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t("page.invitefriend.seller_sign_desc")}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.seller_collect_desc"
                                                            )}
                                                    </>
                                                )}
                                            </div>
                                            <div className="input-popupinvite">
                                                <Input defaultValue={"https://" + inviteUrl} />
                                                <Button
                                                    className="submit"
                                                    type="primary"
                                                    onClick={copyText}
                                                >
                                                    {t("page.copy")}
                                                </Button>
                                            </div>
                                            <div className="center-qr">
                                                <br />
                                                <QRCode value={"https://" + inviteUrl} size={100} />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="share-popupinvite">
                                            <RWebShare
                                                data={{
                                                    text: "Invite url",
                                                    url: ("https://" + inviteUrl).toString(),
                                                    title: "Invite url",
                                                }}
                                            >
                                                <a
                                                // onClick={shareContent}
                                                >
                                                    <ShareIcon color={themes?.themeColor!} />
                                                    {userInfo?.contact?.sellerId
                                                        ? t("page.sharelinkMember")
                                                        : t("page.sharelink")}
                                                </a>
                                            </RWebShare>
                                        </div>
                                    </div>
                                    <div
                                        className="close-popupinvite"
                                        onClick={() => {
                                            setShowPopupInvite(false);
                                        }}
                                    >
                                        <img src="../images/ic-close-invite.svg" alt="" />
                                    </div>
                                </StyledPopupInvite>
                            ) : null}
                            <ComponentMenuBar />
                        </StyledMainPage>
                    ) : (
                        <StyledMainPage
                            style={{ height: fullHeight }}
                            themeColor={themes?.themeColor!}
                        >
                            <div className="corp-lang">
                                <LangDropdown {...{ setComponentsLanguage }} />
                            </div>
                            <div className="wrapper-mainpage">
                                <div className="wrapper-cover-img">
                                    <Skeleton
                                        active
                                        loading={isLoading}
                                        title={true}
                                        paragraph={false}
                                    >
                                        <Carousel dots={false} afterChange={coverSlide}>
                                            {merchant?.themes?.sellerThemeSetting?.banner &&
                                                merchant?.themes?.sellerThemeSetting?.banner[0]?.bannerNormal?.map(
                                                    (item: any, index: any) => (
                                                        <div
                                                            className="layout-cover-img"
                                                            key={index}
                                                            onClick={() =>
                                                                handleClickBottomMenu(
                                                                    item.bannerLink
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                src={item.bannerImage}
                                                                alt="cover"
                                                            />
                                                        </div>
                                                    )
                                                )}
                                        </Carousel>
                                    </Skeleton>
                                </div>
                                <div className="layout-profile">
                                    <div className="box-profile">
                                        <div className="layout-name-profile">
                                            <div className="avatar-profile">
                                                <Avatar
                                                    className="circle-avatar-user"
                                                    shape="circle"
                                                    alt="Avatar"
                                                    src={
                                                        userInfo?.avatar ||
                                                        "../images/img-profile-default-01.png"
                                                    }
                                                />
                                            </div>
                                            {merchant?.themes?.basicThemeSetting?.pointsDisplay
                                                ?.pointsSize === "large" ? (
                                                <>
                                                    <div className="layout-detail-profile">
                                                        <div className="name text-sub-header">
                                                            {merchant?.advanceSettings?.tier
                                                                ?.isFullName
                                                                ? userInfo?.contact?.fullName
                                                                : userInfo?.contact?.firstName +
                                                                  " " +
                                                                  userInfo?.contact?.lastName}{" "}
                                                        </div>
                                                    </div>
                                                    <div className="detail-text">
                                                        <CustomProfile2ndLine
                                                            merchant={merchant as IMerchant}
                                                            typeDetail={typeDetail}
                                                            userInfo={userInfo}
                                                            pointValue={pointValue}
                                                            EYPoint={EYPoint}
                                                            expirePoint={expirePoint}
                                                        />
                                                    </div>
                                                    <div className="detail-text">
                                                        <CustomProfile3rdLine
                                                            merchant={merchant as IMerchant}
                                                            typeDetail={typeDetail}
                                                            userInfo={userInfo}
                                                            pointValue={pointValue}
                                                            EYPoint={EYPoint}
                                                            expirePoint={expirePoint}
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="layout-detail-profile">
                                                    <div className="name text-sub-header">
                                                        {merchant?.advanceSettings?.tier?.isFullName
                                                            ? userInfo?.contact?.fullName
                                                            : userInfo?.contact?.firstName +
                                                              " " +
                                                              userInfo?.contact?.lastName}{" "}
                                                        {/* <div className="tooltip-profile" onClick={() => history.push(PATH_PROFILE)}>
                                                            <StyledTooltip themeColor={themes?.themeColor!}>{t("page.myprofile")}</StyledTooltip>
                                                        </div> */}
                                                    </div>
                                                    <div className="detail-text">
                                                        <CustomProfile2ndLine
                                                            merchant={merchant as IMerchant}
                                                            typeDetail={typeDetail}
                                                            userInfo={userInfo}
                                                            pointValue={pointValue}
                                                            EYPoint={EYPoint}
                                                            expirePoint={expirePoint}
                                                        />
                                                    </div>
                                                    <div className="detail-text">
                                                        <CustomProfile3rdLine
                                                            merchant={merchant as IMerchant}
                                                            typeDetail={typeDetail}
                                                            userInfo={userInfo}
                                                            pointValue={pointValue}
                                                            EYPoint={EYPoint}
                                                            expirePoint={expirePoint}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {merchant?.advanceSettings?.tier?.isMemberShipTier ? (
                                            <div className="layout-tier-right">
                                                <div className="layout-box-circular">
                                                    <CustomProfileCircle
                                                        merchant={merchant as IMerchant}
                                                        userInfo={userInfo}
                                                        pointValue={pointValue}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="layout-tier-right">
                                                <div className="layout-box-circular">
                                                    <CustomProfileCircle
                                                        merchant={merchant as IMerchant}
                                                        userInfo={userInfo}
                                                        pointValue={pointValue}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {merchant?.themes?.sellerThemeSetting?.highlightMenu
                                    ?.isHighLight ? (
                                    <div className="wrapper-ld-mission">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <div className="layout-box">
                                                    {merchant?.themes?.sellerThemeSetting
                                                        ?.highlightMenu?.menuLeft === "News" ? (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() => setShowNews(true)}
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconLeft
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuLeft
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptLeft
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft ===
                                                                    "Gift Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft ===
                                                                    "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationLeft ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextLeft(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() =>
                                                                    handleClickBottomMenu(
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.highlightMenu
                                                                            ?.menuLeftLink!
                                                                    )
                                                                }
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconLeft
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuLeft
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptLeft
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft ===
                                                                    "Gift Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeft ===
                                                                    "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationLeft ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextLeft(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="layout-box left">
                                                    {merchant?.themes?.sellerThemeSetting
                                                        ?.highlightMenu?.menuRight === "News" ? (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() => setShowNews(true)}
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconRight
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuRight
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptRight
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight ===
                                                                    "Gift Card" ? (
                                                                        // { checkPointNotAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight ===
                                                                    "Member Card" ? (
                                                                        // { checkPointAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationRight ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextRight(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() =>
                                                                    handleClickBottomMenu(
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.highlightMenu
                                                                            ?.menuRightLink!
                                                                    )
                                                                }
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconRight
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuRight
                                                                        }
                                                                    </span>

                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptRight
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight ===
                                                                    "Gift Card" ? (
                                                                        // { checkPointNotAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight ===
                                                                    "Member Card" ? (
                                                                        // { checkPointAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>
                                                            {merchant?.themes?.informationRight ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextRight(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="layout-box">
                                                    {merchant?.themes?.sellerThemeSetting
                                                        ?.highlightMenu?.menuLeftTh === "News" ? (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() => setShowNews(true)}
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconLeft
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuLeftTh
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptLeftTh
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh ===
                                                                    "Gift Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh ===
                                                                    "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationLeft ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextLeft(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() =>
                                                                    handleClickBottomMenu(
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.highlightMenu
                                                                            ?.menuLeftLink!
                                                                    )
                                                                }
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconLeft
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuLeftTh
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptLeftTh
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh ===
                                                                    "Gift Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuLeftTh ===
                                                                    "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationLeft ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextLeft(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="layout-box left">
                                                    {merchant?.themes?.sellerThemeSetting
                                                        ?.highlightMenu?.menuRightTh === "News" ? (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() => setShowNews(true)}
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconRight
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuRightTh
                                                                        }
                                                                    </span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptRightTh
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh ===
                                                                    "Gift Card" ? (
                                                                        // { checkPointNotAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh ===
                                                                    "Member Card" ? (
                                                                        // { checkPointAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>

                                                            {merchant?.themes?.informationRight ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextRight(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className="layout-click-box">
                                                            <div
                                                                className="action-click"
                                                                onClick={() =>
                                                                    handleClickBottomMenu(
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.highlightMenu
                                                                            ?.menuRightLink!
                                                                    )
                                                                }
                                                            >
                                                                <div className="layout-box-bg">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.iconRight
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="layout-box-text">
                                                                    <span>
                                                                        {
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.highlightMenu
                                                                                ?.menuRightTh
                                                                        }
                                                                    </span>

                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Gift Card" &&
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRight !==
                                                                        "Member Card" ? (
                                                                        <span className="subtext">
                                                                            {
                                                                                merchant.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.highlightMenu
                                                                                    ?.descriptRight
                                                                            }
                                                                        </span>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh ===
                                                                    "Gift Card" ? (
                                                                        // { checkPointNotAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashNotAllMember &&
                                                                            userInfo?.totalCardCashNotAllMember !==
                                                                                0
                                                                                ? userInfo?.totalCardCashNotAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                                                                    null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.highlightMenu
                                                                        ?.menuRightTh ===
                                                                    "Member Card" ? (
                                                                        // { checkPointAll }
                                                                        <span className="subtext">
                                                                            {userInfo?.totalCardCashAllMember !==
                                                                            0
                                                                                ? userInfo?.totalCardCashAllMember +
                                                                                  " " +
                                                                                  " THB"
                                                                                : "View"}{" "}
                                                                        </span>
                                                                    ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                                                                    null}
                                                                </div>
                                                            </div>
                                                            {merchant?.themes?.informationRight ===
                                                            "" ? null : (
                                                                <div
                                                                    className="information"
                                                                    onClick={() => {
                                                                        setShowTextRight(true);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="../images/ic-information.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ) : null}
                                {showTextLeft ? (
                                    <StlyedInformation themeColor={themes?.themeColor!}>
                                        <div className="control-show-text">
                                            {merchant?.themes?.informationLeft}
                                        </div>
                                        <div
                                            className="close-popupinvite"
                                            onClick={() => {
                                                setShowTextLeft(false);
                                            }}
                                        >
                                            <img src="../images/ic-close-invite.svg" alt="" />
                                        </div>
                                    </StlyedInformation>
                                ) : null}
                                {showTextRight ? (
                                    <StlyedInformation themeColor={themes?.themeColor!}>
                                        <div className="control-show-text">
                                            {merchant?.themes?.informationRight}
                                        </div>
                                        <div
                                            className="close-popupinvite"
                                            onClick={() => {
                                                setShowTextRight(false);
                                            }}
                                        >
                                            <img src="../images/ic-close-invite.svg" alt="" />
                                        </div>
                                    </StlyedInformation>
                                ) : null}

                                {merchant?.themes?.sellerThemeSetting?.isOtherMenu ? (
                                    <div className="wrapper-content-slide">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <Swiper
                                                slidesPerView={4.5}
                                                spaceBetween={10}
                                                pagination={true}
                                            >
                                                {merchant?.themes?.sellerThemeSetting?.otherMenu?.map(
                                                    (item: any, index: any) => (
                                                        <SwiperSlide key={index}>
                                                            <div
                                                                className="layout-content-slide"
                                                                onClick={() => {
                                                                    handleClickMenu(
                                                                        resolveMenuPath(item)
                                                                    );
                                                                }}
                                                            >
                                                                <div className="img-content-slide">
                                                                    <a
                                                                        href={resolveMenuPath(item)}
                                                                        onClick={
                                                                            preventDefaultLinkNavigation
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={item.icon}
                                                                            alt="coverpromotion"
                                                                        />
                                                                    </a>
                                                                </div>
                                                                <a
                                                                    href={resolveMenuPath(item)}
                                                                    onClick={
                                                                        preventDefaultLinkNavigation
                                                                    }
                                                                >
                                                                    {item.titleMenu}
                                                                </a>
                                                                <p>{item.descripMenu}</p>
                                                                {item.isHighLight && (
                                                                    <div className="layout-hot-content">
                                                                        <StyledHighLight
                                                                            themeColor={
                                                                                themes?.themeColor!
                                                                            }
                                                                            color={
                                                                                item.highLightColor
                                                                            }
                                                                        >
                                                                            {item.highLight}
                                                                        </StyledHighLight>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                )}
                                            </Swiper>
                                        ) : (
                                            <>
                                                <Swiper
                                                    slidesPerView={4.5}
                                                    spaceBetween={20}
                                                    pagination={true}
                                                >
                                                    {merchant?.themes?.sellerThemeSetting?.otherMenu?.map(
                                                        (item: any, index: any) => (
                                                            <SwiperSlide key={index}>
                                                                <div
                                                                    className="layout-content-slide"
                                                                    onClick={() =>
                                                                        handleClickMenu(
                                                                            resolveMenuPath(item)
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="img-content-slide">
                                                                        <a
                                                                            href={resolveMenuPath(
                                                                                item
                                                                            )}
                                                                            onClick={
                                                                                preventDefaultLinkNavigation
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={item.icon}
                                                                                alt="coverpromotion"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <a
                                                                        href={resolveMenuPath(item)}
                                                                        onClick={
                                                                            preventDefaultLinkNavigation
                                                                        }
                                                                    >
                                                                        {item.titleMenuTh}
                                                                    </a>
                                                                    <p>{item.descripMenuTh}</p>
                                                                    {item.isHighLight && (
                                                                        <div className="layout-hot-content">
                                                                            <StyledHighLight
                                                                                themeColor={
                                                                                    themeColor
                                                                                }
                                                                                color={
                                                                                    item.highLightColor
                                                                                }
                                                                            >
                                                                                {item.highLight}
                                                                            </StyledHighLight>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </SwiperSlide>
                                                        )
                                                    )}
                                                </Swiper>
                                            </>
                                        )}
                                    </div>
                                ) : null}

                                <div className="wrapper-promotion">
                                    <Carousel afterChange={promotionSlide}>
                                        {merchant?.themes?.sellerThemeSetting?.promotion?.map(
                                            (item: any, index: any) => (
                                                <>
                                                    <div
                                                        className="main-cover-promotion"
                                                        key={index}
                                                        onClick={() =>
                                                            handleClickMenu(item.promotionLink)
                                                        }
                                                    >
                                                        <span>
                                                            {item.promotionImage.endsWith(
                                                                ".mp4"
                                                            ) ? (
                                                                <video
                                                                    width="100%"
                                                                    height="100%"
                                                                    poster={
                                                                        item.promotionVideoPosterImage
                                                                    }
                                                                    controls
                                                                >
                                                                    <source
                                                                        src={item.promotionImage}
                                                                        type="video/mp4"
                                                                    />
                                                                </video>
                                                            ) : (
                                                                // </div>
                                                                <img
                                                                    src={item.promotionImage}
                                                                    alt="coverpromotion"
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                </>
                                            )
                                        )}
                                    </Carousel>
                                    <div className="layout-banner-sq">
                                        {merchant?.themes?.sellerThemeSetting?.banner[0]?.bannerSquare?.map(
                                            (item: any, index: any) => (
                                                <div
                                                    className="box-banner-sq"
                                                    key={index}
                                                    onClick={() => {
                                                        handleClickMenu(item.bannerLink);
                                                        // history.push(item.bannerLink)
                                                    }}
                                                >
                                                    <img src={item.bannerImage} alt="" />
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                            {showNews && newsList?.length > 0 && (
                                <StyledNews themeColor={themes?.themeColor!}>
                                    <div className="wrapper-popup-news">
                                        <Carousel afterChange={newsSlide}>
                                            {newsList?.map((itemNews: any, index: any) => {
                                                if (itemNews.isActivate) {
                                                    return (
                                                        <div key={index}>
                                                            <div className="control-popup-news">
                                                                <div className="img-popup-news">
                                                                    <img
                                                                        src={itemNews?.imageUrl[0]}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="content-popup-news">
                                                                    <h2>{itemNews?.headText}</h2>
                                                                    <div className="datetime-popup-news">
                                                                        {formatDateNumber(
                                                                            itemNews?.createdAt
                                                                        )}
                                                                    </div>
                                                                    <p
                                                                        className={
                                                                            isClicked
                                                                                ? "clicked"
                                                                                : ""
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: itemNews?.discriptionText,
                                                                        }}
                                                                    ></p>
                                                                    <div
                                                                        className="readmore"
                                                                        onClick={handleClickRead}
                                                                    >
                                                                        Read more
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </Carousel>
                                    </div>
                                    <div
                                        className="close-popupinvite"
                                        onClick={() => {
                                            setShowNews(false);
                                        }}
                                    >
                                        <img src="../images/ic-close-invite.svg" alt="" />
                                    </div>
                                </StyledNews>
                            )}
                            <RenderInviteFriend />
                            {/* {renderInviteFriend()} */}
                            {showpopupinvite ? (
                                <StyledPopupInvite themeColor={themes?.themeColor!}>
                                    <div className="box-popupinvite">
                                        <div className="img-popupinvite">
                                            <img
                                                src={
                                                    merchant?.themes?.basicThemeSetting
                                                        ?.iconGeneral[1].image
                                                }
                                                alt=""
                                            />
                                        </div>
                                        <div className="detail-popupinvite">
                                            <div className="title-popupinvite">
                                                <div className="icon-title">
                                                    <IconPoint />{" "}
                                                </div>
                                                {userInfo?.contact?.sellerId &&
                                                merchant?.inviteSellerRule?.isPoint
                                                    ? merchant?.inviteSellerRule?.isPoint
                                                    : merchant?.inviteFriendRules?.isPoint
                                                    ? merchant?.inviteFriendRules?.isPoint
                                                    : ""}{" "}
                                                {t("page.point")}
                                            </div>
                                            <div className="title-popupinvite">
                                                {userInfo?.contact?.sellerId ? (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t(
                                                                "page.invitefriend.friend_sign_title"
                                                            )}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.friend_collect_title"
                                                            )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t(
                                                                "page.invitefriend.seller_sign_title"
                                                            )}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.seller_collect_title"
                                                            )}
                                                    </>
                                                )}
                                                {/* {userInfo?.contact?.sellerId
                                                    ? t("page.invitemembertoget")
                                                    : t("page.invitefriendtoget")}{" "} */}
                                                {/* <div className="icon-title">
                                                    <IconPoint />{" "}
                                                </div> */}
                                            </div>
                                            <div className="desc-popupinvite">
                                                {userInfo?.contact?.sellerId ? (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t("page.invitefriend.friend_sign_desc")}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.friend_collect_desc"
                                                            )}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t("page.invitefriend.friend_sign_desc")}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.friend_collect_desc"
                                                            )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {merchant?.inviteFriendRules
                                                            ?.isFriendSign &&
                                                            t("page.invitefriend.seller_sign_desc")}
                                                        {merchant?.inviteFriendRules
                                                            ?.isFirstCollect &&
                                                            t(
                                                                "page.invitefriend.seller_collect_desc"
                                                            )}
                                                    </>
                                                )}
                                                {/* {userInfo?.contact?.sellerId
                                                    ? t("page.pleasecopyinvitemember")
                                                    : t("page.pleasecopyinvitefriend")} */}
                                            </div>
                                            <div className="input-popupinvite">
                                                <Input defaultValue={"https://" + inviteUrl} />
                                                <Button
                                                    className="submit"
                                                    type="primary"
                                                    onClick={copyText}
                                                >
                                                    {t("page.copy")}
                                                </Button>
                                            </div>
                                            <div className="center-qr">
                                                <br />
                                                <QRCode value={"https://" + inviteUrl} size={100} />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="share-popupinvite">
                                            <RWebShare
                                                data={{
                                                    text: "Invite url",
                                                    url: ("https://" + inviteUrl).toString(),
                                                    title: "Invite url",
                                                }}
                                            >
                                                <a
                                                // onClick={shareContent}
                                                >
                                                    <ShareIcon color={themes?.themeColor!} />
                                                    {userInfo?.contact?.sellerId
                                                        ? t("page.sharelinkMember")
                                                        : t("page.sharelink")}
                                                </a>
                                            </RWebShare>
                                        </div>
                                    </div>
                                    <div
                                        className="close-popupinvite"
                                        onClick={() => {
                                            setShowPopupInvite(false);
                                        }}
                                    >
                                        <img src="../images/ic-close-invite.svg" alt="" />
                                    </div>
                                </StyledPopupInvite>
                            ) : null}
                            <ComponentMenuBar />
                        </StyledMainPage>
                    )}
                </>
            );
        } else {
            return (
                <StyledLayoutSme themeColor={themes?.themeColor!}>
                    <div className="layout-sme">
                        <RenderMeta title={t("meta.home_page")} />
                        {/* <div className="background"></div> */}
                        {!userInfo ? (
                            <div className="preview">
                                <div className="non-login">
                                    <div className="content-non-login">
                                        <div className="title-non-login">
                                            <span>
                                                <img
                                                    src="../../images/logo-rocket-short.svg"
                                                    alt=""
                                                />
                                            </span>
                                            {t("page.welcome_to")} {merchant?.name}
                                        </div>
                                        <div className="desc-non-login">
                                            {t("page.sign_up_now_get")} <IconPoint />{" "}
                                            <span>
                                                {merchant?.initPoint} {t("page.point")}
                                            </span>
                                        </div>
                                    </div>
                                    <StyledBtnNonLogin
                                        themeColor={themeColor}
                                        onClick={() =>
                                            UIStore.setState({
                                                useDrawer: true,
                                                drawerContent: (
                                                    <span
                                                        style={{
                                                            color: "black",
                                                        }}
                                                    >
                                                        <Login />
                                                    </span>
                                                ),
                                            })
                                        }
                                    >
                                        {t("page.login")}
                                    </StyledBtnNonLogin>
                                </div>
                            </div>
                        ) : (
                            <div className="preview">
                                <div className="avatar-layout">
                                    {userInfo?.avatar ? (
                                        <div
                                            onClick={handleSwitchUserSetting}
                                            className="circle-avatar-user-layout"
                                        >
                                            <Avatar
                                                className="circle-avatar-user"
                                                shape="circle"
                                                alt="Avatar"
                                                style={styleCircleImg}
                                                size={62}
                                                src={userInfo?.avatar}
                                            />
                                        </div>
                                    ) : (
                                        <IConUser
                                            className="ant-avatar"
                                            style={styleAvatarUser}
                                            onClick={handleSwitchUserSetting}
                                        />
                                    )}
                                </div>
                                <div className="profile-info">
                                    <div className="avatar_name">
                                        <div className="hello text-body eng">
                                            {userInfo?.contact?.fullName && "Hello"}{" "}
                                        </div>
                                        <div className="name text-sub-header eng">
                                            {merchant?.advanceSettings?.tier?.isFullName
                                                ? userInfo?.contact?.fullName
                                                : userInfo?.contact?.firstName +
                                                  " " +
                                                  userInfo?.contact?.lastName}{" "}
                                        </div>
                                    </div>
                                    <div className="user-actions">
                                        <div
                                            className="star"
                                            onClick={() => {
                                                history.push(PATH_MY_QR);
                                            }}
                                        >
                                            <IconStarCircle
                                                stoke={modeColor}
                                                color={themes?.themeColor!}
                                            />
                                        </div>
                                        <div className="rank-layout">
                                            <BudgeButton
                                                onClick={handleDetail}
                                                themeColor={themes?.themeColor!}
                                                color={tierColor || ""}
                                                icon={userInfo?.memberTier?.icon || ""}
                                                tierName={userInfo?.memberTier?.tierName}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="user-progress">
                                    <StyledProgressBar
                                        percentage={percentage}
                                        color={themes?.themeColor!}
                                        showInfo={false}
                                    />
                                    <div className="progress-info">
                                        <p className="label text-small active-font eng">
                                            {userInfo?.memberCode}
                                        </p>
                                        <StyledProgressText themeColor={themes?.themeColor!}>
                                            {nextTiers.length > 0 && (
                                                <p className="text text-small">
                                                    {t("page.earn")}
                                                    <span className="next-spendBath eng">
                                                        {nextTierAmount}{" "}
                                                        {merchant?.advanceSettings?.tier
                                                            ?.isTierBySale
                                                            ? t("page.baht")
                                                            : t("page._points")}
                                                    </span>{" "}
                                                    {t("page.upgrade")}{" "}
                                                    <span className="eng">
                                                        {nextTiers[0].membershipName}
                                                    </span>
                                                </p>
                                            )}
                                        </StyledProgressText>
                                    </div>
                                </div>
                                <div className="star_coupans">
                                    <div className="star_point righttoleft">
                                        <StyledIconStarSub
                                            stoke={modeColor}
                                            color={themes?.themeColor!}
                                            onClick={handleSwitchTier}
                                        />
                                        <div className="control-detail">
                                            <span
                                                className="point text-extra eng"
                                                onClick={handleSwitchTier}
                                            >
                                                {numberFormatter(userInfo?.totalPoints || 0)}
                                            </span>
                                            <span className="desc" onClick={handleSwitchTier}>
                                                {t("page._points")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="star_point righttoleft2s">
                                        <StyledCoupon
                                            stoke={modeColor}
                                            color={themes?.themeColor!}
                                            onClick={() => callback("5")}
                                        />
                                        <div className="control-detail">
                                            <span
                                                className="point text-extra eng"
                                                onClick={() =>
                                                    handleToggleUnder(
                                                        enumNavigation.COUPON_MERCHANT
                                                    )
                                                }
                                            >
                                                {numberFormatter(userInfo?.totalCoupons)}{" "}
                                                <span className="coupon text-sec-sub-header">
                                                    {t("page.coupon")}
                                                </span>
                                            </span>
                                            <span className="desc" onClick={() => callback("5")}>
                                                {t("page.coupons")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <StyledMainPageSecond themeColor={themes?.themeColor!}>
                            {haveInvite && false && (
                                <div
                                    className="box-invite-friend"
                                    onClick={() => {
                                        setShowPopupInvite(true);
                                    }}
                                >
                                    <img
                                        src={
                                            merchant?.themes?.basicThemeSetting?.iconGeneral[2]
                                                .image
                                        }
                                        alt="invite-friend"
                                    />
                                </div>
                            )}
                        </StyledMainPageSecond>
                        <Tabs defaultActiveKey="1" activeKey={tab} onChange={callback}>
                            <TabPane tab={t("page.use_point")} key="1"></TabPane>
                            <TabPane tab={t("page.benefits")} key="2"></TabPane>
                            <TabPane tab={t("page.coupons")} key="5"></TabPane>
                            <TabPane tab={t("page.history")} key="4"></TabPane>
                        </Tabs>
                    </div>
                </StyledLayoutSme>
            );
        }
    };
    return <>{isLoading ? renderCorporateUi() : renderCorporateUi()}</>;
    // return <>{isLoading ? <StyledLoading /> : renderCorporateUi()}</>;
};

const StyledBtnNonLogin = styled.button<{ themeColor: string }>`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    padding: 8px 20px;
    background-color: ${(p) => p.themeColor};
    color: #fff;
    border-radius: 10px;
    border: none;
`;

const StyledLayoutSme = styled.div<{ themeColor: string }>`
    margin-top: -60px;
    .layout-sme {
        background-color: #f6f6f6;
    }
    .preview {
        .non-login {
            padding-right: 100px;
            position: relative;
            .content-non-login {
                position: relative;
                .title-non-login {
                    display: flex;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                    color: #454545;
                    margin-bottom: 10px;
                    align-items: center;
                    span {
                        margin-right: 10px;
                        img {
                            height: 17px;
                        }
                    }
                }
                .desc-non-login {
                    font-size: 12px;
                    line-height: 15px;
                    color: #000;
                    display: flex;
                    gap: 4px;
                    align-items: center;
                    span {
                        color: #f4be33;
                    }
                }
            }
        }
    }
`;

const StlyedMemberType = styled.div<{ themeColor: string }>`
    display: flex;
    width: 60px;
    height: 60px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 5px solid ${(p) => p.themeColor};
    img {
        width: 35px;
        height: auto;
    }
`;

const StyledMemberTier = styled.div<{ color: string }>`
    span {
        color: ${(props) => props.color || "#000"};
        /* font-weight: 600; */
    }
`;
const StyledShowVideo = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 20px;
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;
const StyledNews = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 20px;
    .wrapper-popup-news {
        border-radius: 12px;
        overflow: hidden;
        position: relative;
        width: 100%;
        .control-popup-news {
            position: relative;
            display: block;
            z-index: 9;
        }
        .img-popup-news {
            height: 75dvh;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            &:after {
                content: "";
                z-index: 0;
                position: absolute;
                bottom: -5px;
                left: 0px;
                border-radius: 12px;
                width: calc(100% + 16px);
                height: calc(100% + 16px);
                background: rgb(0, 0, 0);
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.7) 0%,
                    rgba(255, 255, 255, 0) 50%
                );
            }
        }
        .slick-dots-bottom {
            width: 100%;
            display: flex !important;
            flex-direction: row;
            justify-content: space-between;
            top: 12px;
            padding: 0 16px;
            height: 20px;
            li {
                width: 100%;
                margin: 0;
                border-radius: 0;
                flex-grow: 1;
                height: 9px;
                margin-right: 2px;
                position: relative;
                button {
                    width: 100%;
                    background-color: #fff;
                }
            }
            li.slick-active {
                button {
                    background-color: #fff !important;
                }
            }
        }
        .popup-test {
            position: absolute;
            left: 12px;
            top: 50%;
        }
        .content-popup-news {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 32px 16px;
            h2 {
                font-size: 20px;
                line-height: 23px;
                margin-bottom: 8px;
                font-weight: 600;
                color: #fff;
            }
            .datetime-popup-news {
                background-image: url(../../images/ic-datetime.svg);
                background-position: left center;
                background-repeat: no-repeat;
                background-size: 10px;
                font-size: 10px;
                line-height: 13px;
                color: #c9c5bc;
                margin-bottom: 8px;
                padding-left: 16px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #fff;
                display: -webkit-box;
                -webkit-line-clamp: initial;
                -webkit-box-orient: vertical;
                overflow: hidden;
                p:last-child {
                    -webkit-line-clamp: 3;
                }
            }
            p.clicked {
                -webkit-line-clamp: initial;
                p {
                    -webkit-line-clamp: initial;
                }
            }
            .readmore {
                font-weight: 600;
                color: ${(p) => p.themeColor};
            }
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;
const StlyedInformation = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 20px;
    .control-show-text {
        background-color: #fff;
        padding: 16px;
        border-radius: 16px;
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

const StyledHighLight = styled.span<{ themeColor: string }>`
    position: relative;
    color: #fff;
    background-color: ${(props) => props.color || props.themeColor};

    font-size: 12px;
    line-height: 14px;
    padding: 4px 8px 6px;
    border-radius: 4px;
    z-index: 2;
    &:after {
        content: "";
        width: 7px;
        height: 7px;
        background-color: ${(props) => props.color || props.themeColor};
        position: absolute;
        bottom: -6px;
        left: 50%;
        rotate: 45deg;
        transform: translateX(-50%);
        z-index: 1;
    }
`;

const StyledPopupInvite = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .box-popupinvite {
        // background: ${(p) => p.theme.colors.card};
        background: #fff;
        /* background: linear-gradient(0deg, rgba(255, 255, 255, 1) 70%, rgba(196, 163, 99, 1) 100%); */
        padding: 70px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        margin-bottom: 40px;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupinvite {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                width: 100%;
                max-width: 150px;
            }
        }
        .detail-popupinvite {
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 0.5px solid #c0cbde;
            position: relative;
            &:after {
                content: "Or";
                background-color: #fff;
                padding: 0 20px;
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 16px;
                color: #9b9b9b;
            }
            .title-popupinvite {
                font-size: 22px;
                line-height: 26px;
                font-weight: 600;
                color: #000;
                margin-bottom: 5px;
                text-align: center;
                .icon-title {
                    position: relative;
                    top: -3px;
                    margin: 0 5px;
                    display: inline-block;
                }
            }
            .desc-popupinvite {
                font-size: 16px;
                line-height: 23px;
                color: #9b9b9b;
                margin-bottom: 30px;
                text-align: center;
            }
            .input-popupinvite {
                position: relative;
                padding-right: 90px;
                margin-bottom: 20px;
                input {
                    min-height: 48px !important;
                    border-radius: 0;
                    border-top-left-radius: 14px;
                    border-bottom-left-radius: 14px;
                    border-top-right-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                    border-color: ${(p) => p.themeColor};
                    font-size: 13px;
                }
                .submit {
                    position: absolute;
                    width: 90px;
                    height: 48px;
                    right: 0;
                    top: 0;
                    border-radius: 0;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    background-color: ${(p) => p.themeColor};
                    border-color: ${(p) => p.themeColor};
                    padding-left: 35px;
                    background-image: url(../../images/ic-copy.svg);
                    background-size: 14px;
                    background-repeat: no-repeat;
                    background-position: 16px center;
                }
            }
            .center-qr {
                text-align: center;
            }
        }
        .share-popupinvite {
            text-align: center;
            padding: 16px 0 0;
            a {
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                /* padding-left: 26px; */
                /* background-image: url(../../images/ic-share.svg); */
                background-size: 16px;
                background-repeat: no-repeat;
                background-position: left center;
                svg {
                    margin-right: 10px;
                }
            }
        }
    }
    .close-popupinvite {
        img {
            width: 32px;
        }
    }
`;

const StyledDotCircular = styled.div<{ rotatevalue: string; colortier: string | undefined }>`
    transform: rotate(${(props) => (parseInt(props.rotatevalue) * 360) / 100 + "deg" || 0 + "deg"});
    position: absolute;
    .dot-circular {
        width: 6px;
        height: 6px;
        background-color: ${(props) => props.colortier};
        transform: translateY(-40px);
        border-radius: 100%;
    }
`;

const StyledIconStarSub = styled(IconCoinSub)`
    cursor: pointer;
`;

const StyledCoupon = styled(Coupon)`
    cursor: pointer;
`;

const StyledProgressBar = styled(ProgressBar)`
    cursor: pointer;
`;
const StyledProgressText = styled.div<{ themeColor: string }>`
    .next-spendBath {
        color: ${(p) => p.themeColor};
    }
`;
// const StyledColorTier = styled.p.attrs({
//     color: props => props.color || '#000',
// })`
// color: ${props => props.color};
// `;

// const StyledColorTier = styled.p.attrs({
//     color: props => props.color || '#000',
// })``;

const StyledDetailMemberType = styled.div<{ themeColor: string }>`
    .memtype-content {
        padding: 2px 5px;
        background-color: ${(p) => p.themeColor}20;
        border-radius: 12px;
        font-weight: 500;
        font-size: 10px;
        color: ${(p) => p.themeColor};
        display: flex;
        align-items: center;
        span {
            margin-right: 5px;
            line-height: 13px;

            img {
                width: 16px;
                height: 16px;
                border-radius: 100%;
            }
        }
        span.text {
            max-width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
`;

const StyledColorTier = styled.p`
    color: ${(props) => props.color || "#000"};
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70px;
    font-weight: 600;
    text-align: center;
`;

const StyledMainPage = styled.div<{ themeColor: string }>`
    position: relative;
    /* top: -112px; */
    margin-top: 0;
    height: 100dvh;
    .corp-lang {
        position: absolute;
        z-index: 2;
        right: 0;
        top: 0;
        padding: 15px;
    }
    .box-invite-friend {
        position: fixed;
        bottom: 100px;
        right: 16px;
        z-index: 1;
        cursor: pointer;
        img {
            width: 90px;
            height: 85px;
        }
    }

    .layout-profile {
        padding: 0 16px;
        margin-top: -50px;
        margin-bottom: 20px;
        .ant-skeleton {
            background-color: #fff;
            border-radius: 14px;
            width: 100%;
            min-height: 100px;
            padding: 16px 20px;
            position: relative;
            .ant-skeleton-title {
                height: 10px;
            }
            .ant-skeleton-paragraph {
                margin-top: 8px;
                li {
                    margin-top: 8px;
                    height: 10px;
                }
            }
        }
        .layout-tier-right {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            .layout-box-circular {
                /* position: relative; */
                .box-circular {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    // &:after {
                    //     position: absolute;
                    //     content: '';
                    //     width: 100%;
                    //     height: 100%;
                    //     top: 0;
                    //     left: 0;
                    //     background-color: rgba(0, 0, 0, 0.3);
                    // }
                    .CircularProgressbar {
                        width: 90px;
                    }
                    .CircularProgressbar-path {
                        stroke-width: 8;
                    }
                    .CircularProgressbar-trail {
                        stroke-width: 8;
                    }
                }
                .text-circular {
                    position: absolute;
                    color: ${(p) => p.themeColor};
                    top: 50%;
                    right: 50%;
                    transform: translate(50%, -50%);
                    line-height: 18px;
                    p {
                        font-size: 12px !important;
                    }
                }
            }
        }
    }
    .layout-cover-img {
        img {
            width: 100%;
        }
    }
    .wrapper-cover-img {
        .ant-skeleton-content {
            .ant-skeleton-title {
                height: 400px;
                margin-top: 0;
            }
        }
    }

    .box-profile {
        background-color: #fff;
        border: 1.3px solid ${(p) => p.themeColor};
        border-radius: 14px;
        width: 100%;
        min-height: 100px;
        padding: 16px 20px;
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: row;
        .non-login {
            padding-right: 100px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: calc(100% - 32px);
            .content-non-login {
                position: relative;
                .title-non-login {
                    display: flex;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                    color: #454545;
                    margin-bottom: 10px;
                    align-items: center;
                    span {
                        margin-right: 10px;
                        img {
                            height: 17px;
                        }
                    }
                }
                .desc-non-login {
                    font-size: 12px;
                    line-height: 15px;
                    color: #000;
                    display: flex;
                    gap: 4px;
                    align-items: center;
                    span {
                        color: #f4be33;
                    }
                }
            }
        }
        .ant-skeleton-content .ant-skeleton-paragraph {
            margin-top: 8px !important;
            li + li {
                margin-top: 8px;
            }
        }
        .layout-name-profile {
            padding-left: 50px;
            margin-bottom: 5px;
        }
        .avatar-profile {
            width: 40px;
            height: 40px;
            border-radius: 100%;
            overflow: hidden;
            position: absolute;
            top: 20px;
            left: 16px;
            .ant-avatar {
                border-radius: 100%;
                width: 40px;
                height: 40px;
                border: 1px solid ${(p) => p.themeColor};
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .layout-detail-profile {
            display: block;

            .name {
                width: 200px;
                font-size: 18px;
                line-height: 25px;
                margin-bottom: 5px;
                position: relative;
                display: inline-block;
                .tooltip-profile {
                    position: absolute;
                    top: -30px;
                    min-width: 90px;
                    left: 50%;
                    transform: translateX(-30%);
                }
            }
            .point {
                // background-image: url(../../images/ic-point.png);
                // background-size: 25px;
                // background-repeat: no-repeat;
                // padding-left: 27px;
                // background-position: -2px 4px;
                line-height: 26px;
                margin-bottom: 5px;
                color: #525257;
                font-size: 14px;
                display: flex;
                align-items: center;
                span {
                    color: ${(p) => p.themeColor};
                    font-weight: 600;
                    font-size: 14px;
                    margin-right: 5px;
                }
                span.text-small {
                    font-size: 14px;
                }
                span.text-medium {
                    font-size: 18px;
                }
                span.text-large {
                    font-size: 25px;
                }
                span.icpoint {
                    margin-right: 0px;
                }
                span.text-point {
                    position: relative;
                    top: 5px;
                }
            }
            .coupon {
                background-image: url(../../images/ic-coupon.svg);
                background-size: 20px;
                background-repeat: no-repeat;
                padding-left: 27px;
                background-position: left 4px;
                // margin-left: 10px;
                color: #525257;
                font-size: 13px;
                line-height: 17px;
            }
            .test-text-big {
                span {
                    font-size: 30px !important;
                }
            }
            .detail-text {
                background-size: 20px;
                background-repeat: no-repeat;
                background-position: left 4px;
                color: #525257;
                font-size: 12px;
                line-height: 16px;
                display: flex;
                align-items: center;
                flex-direction: row;
                margin-bottom: 5px;
                span {
                    &:first-child {
                        margin-right: 5px;
                    }
                }
                &:last-child {
                    margin-bottom: 0;
                }
                .small {
                    span {
                        font-size: 12px !important;
                    }
                }
                .medium {
                    span {
                        font-size: 14px !important;
                    }
                }
                .large {
                    span {
                        font-size: 16px !important;
                    }
                }
                .largest {
                    span {
                        font-size: 16px !important;
                    }
                }
                .bold-text {
                    font-weight: 500 !important;
                }
                .memtype-style {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0px 8px 0px 0px;
                    color: ${(p) => p.themeColor};
                    background-color: ${(p) => p.themeColor}20;
                    border-radius: 50px;
                    margin-right: 6px;
                    span {
                        font-weight: 500;
                    }
                    img {
                        border-radius: 50px;
                        /* border: 1px solid ${(p) => p.themeColor}; */
                        background-color: #fff;
                        width: 18px;
                        height: 18px;
                        margin: 5px;
                        object-fit: cover;
                    }
                }
                /* .text-bottom {
                    margin-top: 4px;
                } */
                .textbold {
                    font-weight: 500;
                }
            }
        }
    }
    .wrapper-content-slide {
        margin: 0 16px 16px;
        // padding-top:16px;
        .ant-skeleton {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            .ant-skeleton-header {
                padding-right: 0;
            }
            .ant-skeleton-paragraph {
                text-align: center;
                width: 100%;
                display: table;
                margin: 0 auto;
                li {
                    margin: 0 auto;
                    margin-top: 5px;
                    border-radius: 16px;
                    height: 10px;
                }
            }
        }
        .swiper-slide {
            height: auto;
        }
        .swiper-pagination {
            bottom: 0;
            display: flex;
            justify-content: center;
            .swiper-pagination-bullet {
                background-color: ${(p) => p.themeColor};
                margin: 0;
                border-radius: 0;
                width: 16px;
                height: 3px;
                &:first-child {
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                }
                &:last-child {
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                }
            }
            .swiper-pagination-bullet-active {
                border-radius: 10px;
            }
        }
        .layout-content-slide {
            text-align: center;
            display: inline-block;
            width: 90px;
            // margin-right:40px;
            position: relative;
            margin-bottom: 10px;
            padding: 30px 5px 0;
            a {
                font-size: 12px;
                line-height: 14px;
                color: #000;
                font-weight: 500;
                word-wrap: break-word;
                @media (max-width: 400px) {
                    font-size: 10px;
                    line-height: 13px;
                }
            }
            p {
                font-size: 10px;
                line-height: 12px;
                color: #9b9b9b;
            }
            .img-content-slide {
                width: 50px;
                height: 50px;
                // border-radius: 100%;
                overflow: hidden;
                margin: 0 auto 10px;
                @media (max-width: 400px) {
                    width: 30px;
                    height: 30px;
                }
                a {
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .layout-hot-content {
                position: absolute;
                top: 0;
                width: 100%;
                display: flex;
                justify-content: center;
            }
        }
    }
    .wrapper-ld-mission {
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 0 16px;
        margin: 10px 0;
        .ant-skeleton {
            margin-bottom: 20px;
            .ant-skeleton-paragraph {
                text-align: center;
                width: 100%;
                display: table;
                margin: 0 auto;
                li {
                    margin: 0 auto;
                    margin-top: 12px;
                    border-radius: 16px;
                    height: 10px;
                }
            }
        }
        @media (max-width: 400px) {
            grid-template-columns: 1fr 1fr;
        }
        .layout-box.left {
            margin-left: 15px;
            @media (max-width: 400px) {
                margin-left: 0;
            }
        }
        .layout-box {
            padding: 16px 0;
            text-align: center;
            position: relative;
            margin-left: 5px;
            @media (max-width: 400px) {
                margin-left: 0;
            }
            .information {
                // position: absolute!important;
                right: -10px;
                top: 0;
                z-index: 2;
                img {
                    width: 10px;
                }
            }
            .layout-click-box {
                position: relative;
                padding-right: 15px;
                display: flex;
                gap: 12px;
                justify-content: space-between;
                .action-click {
                    display: flex;
                    gap: 12px;
                }
                &:after {
                    content: "";
                    width: 1px;
                    height: 42px;
                    background-color: #e1e1e1;
                    position: absolute;
                    right: -8px;
                    top: 50%;
                    transform: translateY(-50%);
                    /* @media (max-width: 400px) {
                        width: 100%;
                        height: 1px;
                        top: auto;
                        left: 0;
                        transform: translateY(0%);
                        bottom: 0;
                    } */
                }
            }
            .layout-click-box {
                &:last-child {
                    &:after {
                        display: none;
                    }
                }
            }

            .layout-box-bg {
                position: relative;
                z-index: 1;
                img {
                    width: 40px;
                    opacity: 1;
                    @media (max-width: 400px) {
                        width: 30px;
                    }
                }
            }
            .layout-box-text {
                position: relative;
                text-align: left;
                z-index: 1;
                padding-right: 10px;
                span {
                    display: block;
                    color: #000;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 5px;
                    position: relative;
                    @media (max-width: 400px) {
                        font-size: 13px;
                        line-height: 16px;
                    }
                }

                span.subtext {
                    color: #9b9b9b;
                    font-size: 11px;
                    line-height: 12px;
                    /* padding-right: 12px; */
                    /* background-image: url(../../images/double-arrow-right.svg); */
                    background-size: 6px;
                    background-repeat: no-repeat;
                    background-position: right 55%;
                    font-weight: normal;
                }
            }
        }
        .mission {
            background-image: url(../../images/bg-mission.png);
            background-repeat: no-repeat;
            background-position: 5px center;
        }
    }
    .wrapper-promotion {
        .ant-skeleton {
            .ant-skeleton-title {
                border-radius: 3px;
            }
            .ant-skeleton-paragraph {
                margin-top: 12px;
                li {
                    width: 100% !important;
                    border-radius: 14px;
                    height: 150px;
                }
            }
        }
        padding: 0 16px 90px;
        .ant-carousel .slick-dots li.slick-active button {
            background-color: ${(p) => p.themeColor}!important;
        }
        .layout-banner-sq {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
            .box-banner-sq {
                border-radius: 14px;
                overflow: hidden;
                img {
                    width: 100%;
                }
            }
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    margin-top: 12px;
                    li {
                        width: 100% !important;
                        border-radius: 14px;
                        height: 110px;
                    }
                }
            }
        }
        .topic-promotion {
            font-size: 16px;
            line-height: 20px;
            color: #000;
            font-weight: 600;
            margin-bottom: 15px;
            span {
                font-size: 12px;
                line-height: 20px;
                color: #9b9b9b;
            }
        }
        .main-cover-promotion {
            position: relative;
            width: 100%;
            padding-top: 56.25%;
            border-radius: 14px;
            overflow: hidden;
            margin-bottom: 16px;
            video {
                object-fit: fill;
            }
            span {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }
        .layout-promotion {
            // display: grid;
            // grid-template-columns: 1fr 1fr;
            // gap: 16px;
            .control-slide {
                display: grid;
                grid-template-columns: 1fr;
            }
            .control-img-1 {
                position: relative;
                width: 100%;
                padding-top: 120%;
                border-radius: 14px;
                overflow: hidden;
                margin-bottom: 16px;
                a {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .control-img-2 {
                position: relative;
                width: 100%;
                padding-top: 55.5%;
                border-radius: 14px;
                overflow: hidden;
                margin-bottom: 16px;
                a {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .control-img-3 {
                position: relative;
                width: 100%;
                padding-top: 110%;
                border-radius: 14px;
                overflow: hidden;
                margin-bottom: 16px;
                a {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
        .layout-newproduct {
            position: relative;
            margin-bottom: 15px;
            padding: 15px 0;
            padding-left: 90px;
            .box-newproduct {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                a {
                    img {
                        max-width: 100%;
                    }
                }
            }
            .topic-newproduct {
                font-size: 12px;
                color: #000;
            }
            .name-newproduct {
                font-size: 16px;
                line-height: 20px;
                color: #000;
                font-weight: 700;
                span {
                    color: #336c51;
                    font-weight: 700;
                }
            }
        }
    }
`;

const StyledMainPageSecond = styled.div<{ themeColor: string }>`
    position: relative;
    // top: -112px;
    /* margin-top:-112px; */
    .box-invite-friend {
        position: fixed;
        bottom: 100px;
        right: 16px;
        z-index: 1;
        cursor: pointer;
        img {
            width: 110px;
            height: 105px;
        }
    }
`;
